// Enable mouse drag scrolling for product media list
document.addEventListener('DOMContentLoaded', () => {
  const mediaList = document.querySelector('.product__media-list');
  if (!mediaList) return;

  let isMouseDown = false;
  let startX;
  let scrollLeft;

  const startDragging = (e) => {
    isMouseDown = true;
    mediaList.classList.add('grabbing');
    startX = e.pageX - mediaList.offsetLeft;
    scrollLeft = mediaList.scrollLeft;
  };

  const stopDragging = () => {
    isMouseDown = false;
    mediaList.classList.remove('grabbing');
  };

  const move = (e) => {
    if (!isMouseDown) return;
    e.preventDefault();
    const x = e.pageX - mediaList.offsetLeft;
    const walk = (x - startX) * 2; // Scroll speed multiplier
    mediaList.scrollLeft = scrollLeft - walk;
  };

  // Mouse event listeners - attach to document for tracking outside element
  mediaList.addEventListener('mousedown', startDragging);
  document.addEventListener('mouseup', stopDragging);
  document.addEventListener('mousemove', move);
});
